import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppLoadModule } from '@app/core/modules/app-load/app-load.module';
import { ThemeService } from '@app/core/services/theme.service';
import { SharedModule } from '@app/shared/shared.module';
import { ApiRequestInterceptor } from './interceptors/api-request.interceptor';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { MediaMatcherService } from './services/media-matcher.service';

const pages = [NotFoundPageComponent];
const components = [NotFoundPageComponent];
const modules = [BrowserModule, SharedModule];

@NgModule({
  imports: [AppLoadModule, ...modules],
  declarations: [...components, ...pages],
  providers: [
    MediaMatcherService,
    ThemeService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiRequestInterceptor,
      multi: true,
    },
  ],
  exports: [...modules, ...components],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
